import React from "react";
import casenectLogo from "../../../../assets/images/logo/CASENECT_Logo-removebg.png";

function DrawerHeader() {
  return (
    <div style={styles.header}>
      <img src={casenectLogo} alt="CaseNect" style={{ height: 32 }} />
    </div>
  );
}

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    padding: "12px 30px",
    // borderBottom: "1px solid rgba(255,255,255,0.2)",
    minHeight: 60,
  },
};

export default DrawerHeader;
